import React from 'react';
import Hero from '../../components/ui/Hero';
import TrophyList from '../../components/trophies/TrophyList';
import { useTrophies } from '../../hooks/useTrophies';
import { useAuth } from '../../hooks/useAuth';
import { Trophy } from 'lucide-react';

const TrophiesPage = () => {
  const { user } = useAuth();
  const { trophies, isLoading } = useTrophies(user?.id);

  return (
    <div>
      <Hero
        title="My Trophies"
        description="View your earned achievements and contributions"
        compact
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="card p-6">
          {isLoading ? (
            <div className="text-center py-8 text-content-secondary">
              Loading trophies...
            </div>
          ) : trophies.length === 0 ? (
            <div className="text-center py-8">
              <Trophy className="w-12 h-12 text-brand mx-auto mb-4" />
              <h2 className="text-xl font-semibold mb-2">No Trophies Yet</h2>
              <p className="text-content-secondary">
                Start contributing to earn your first trophy!
              </p>
            </div>
          ) : (
            <TrophyList trophies={trophies} />
          )}
        </div>
      </div>
    </div>
  );
};

export default TrophiesPage;